/**
 * Cookie操作のためのユーティリティ関数
 */

/**
 * Cookieから指定されたキーの値を取得
 * @param key - 取得したいCookieのキー
 * @returns 見つかった場合はその値、見つからない場合は空文字
 */
export const getCookie = (key: string): string => {
   if (typeof document === 'undefined') {
    return '';
  }
  const trimmedKey = key.trim();
  const cookies = document.cookie.split(';');

  for (let cookie of cookies) {
    const trimmedCookie = cookie.replace(/\s/g, '');
    if (trimmedCookie.startsWith(trimmedKey + '=')) {
      return decodeURIComponent(trimmedCookie.substring(trimmedKey.length + 1));
    }
  }

  return '';
};
